import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { initCallTracking } from "@/adsConfig";
import Landing from "@/pages/Landing";
import CityPage from "@/pages/CityPage";
import ServicePage from "@/pages/ServicePage";
import PricingGuide from "@/pages/PricingGuide";
import JunkRemovalCost from "@/pages/JunkRemovalCost";
import Contact from "@/pages/Contact";
import ServiceAreas from "@/pages/ServiceAreas";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import ReviewBooster from "@/pages/ReviewBooster";
import AdminLogin from "@/pages/AdminLogin";
import BookPickup from "@/pages/BookPickup";
import MobileCTA from "@/components/MobileCTA";
import AdminDashboard from "@/pages/AdminDashboard";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";

function AppRoutes() {
  const location = useLocation();
  useEffect(() => { initCallTracking(); }, []);
  // Process OAuth callback FIRST (session_id arrives in the URL fragment).
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/junk-removal/:slug" element={<CityPage />} />
      <Route path="/services/:slug" element={<ServicePage />} />
      <Route path="/pricing-and-disposal-guide" element={<PricingGuide />} />
      <Route path="/junk-removal-cost" element={<JunkRemovalCost />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/review" element={<ReviewBooster />} />
      <Route path="/leave-a-review" element={<ReviewBooster />} />
      <Route path="/service-areas" element={<ServiceAreas />} />
      <Route path="/book" element={<BookPickup />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <AppRoutes />
            <MobileCTA />
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
